export default "__VITE_ASSET__cff41246__"